import BgImg from "../assests/backgroundImage6.avif";
import { motion } from "framer-motion";
import React, { useState } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useMediaQuery, useTheme } from "@mui/material";

const Faq = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down(890));
    const [expanded, setExpanded] = useState(false);


    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const faqs = [
        { question: "What is your pricing?", answer: "Our pricing is tailored specifically to your budget and the scope of work required. We believe in crafting unique solutions rather than offering a generic package. The key performance indicators (KPIs) we establish are always designed to ensure profitability for you. Our goal is to create a partnership that is both financially beneficial and strategically aligned with your business objectives" },
        {
            question: "How will it be different from what we're doing currently?",
            answer:
                "We'll be able to give you the best answer after checking your ads. But here's how we do things differently: Instead of throwing stuff at the wall & hoping some sticks, we carefully pick the best foundations of your advertising and build on them to make them even better. This creates a strong momentum that keeps growing.",
        },
        { question: "Do you have any lock-in contract?", answer: "Absolutely not. We prioritize providing our clients with options, believing firmly in the power of choice. Through our commitment to delivering exceptional results and experiences rather than tying clients into contracts, we've observed an increase in client retention rates over time.Nevertheless, we do emphasize the importance of trusting the process and understanding that success takes time. Rapid success rarely occurs in any business, and it's crucial to prioritize long-term strategies over short-term gains. Rest assured, we're dedicated to guiding our clients towards sustainable growth and success." },
        { question: "What if I simply hire in-house instead?", answer: "We've collaborated with brands of all sizes, including those with extensive marketing departments. We believe in leveraging collective expertise to achieve optimal results. By integrating your team and resources with our proven processes, we work together seamlessly to propel you toward your goals. Your success is our priority, and we're committed to maximizing every opportunity to help you succeed" },
        {
            question: "Why should I work with GroMedia instead of 99 other agencies?", answer: `
            While we prioritize delivering exceptional results and experiences to our clients, we don't dwell on our competitors. Your satisfaction and success are our main focus.
            Ultimately, the choice is yours, and we encourage you to select the option that aligns best with your needs and values.

            It's important to note that we're selective about the clients we work with. This isn't about quantity for us; it's about quality. We've learned that the wrong client match can be a disservice to both parties.

            Rather than expanding our client base indiscriminately, we maintain a close-knit team dedicated to high performance. Our approach is to increase the value we provide to our clients, which in turn reflects in our compensation.

            Our guiding principle is simple: how can we deliver the best possible outcomes for our clients? If you're seeking a dedicated partner committed to achieving exceptional results rather than settling for the bare minimum, then we're the team you've been looking for.
            `
        },
        {
            question: "What kind of businesses GroMedia works with?", answer: `
            At our agency, we prioritize the specific needs and potential of each brand, rather than focusing solely on their size.

We've had the privilege of assisting brands across a wide spectrum, from those generating multiple six figures per month to smaller brands operating at around $10k/month. In many cases, we've helped these businesses achieve remarkable growth, scaling to multiple six figures per month and beyond.

However, it's important to note that we're selective about the brands we work with. Regardless of size, we only partner with those who possess the essential prerequisites for success as outlined above. This means that we may occasionally decline partnerships with brands, whether they're operating at $10k/month or $100,000/month, if they don't meet these criteria.

If your brand meets these prerequisites and you're seeking to enhance your results, scale your business, and establish a long-term partnership focused on your success, we encourage you to schedule a call with us today. We're committed to helping you achieve your goals.`}
    ];

    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <Box style={{ marginTop: 50 }}>
                    <Typography variant={isMobile ? "h5" : "h4"} fontWeight="bold" sx={{ marginBottom: "30px", zIndex: 1, color: 'black' }}>
                        Frequently Asked Questions
                    </Typography>

                    <Box sx={{ width: isMobile ? "100%" : "70%", margin: "auto", marginTop: 8 }}>
                        {faqs.map((faq, index) => (
                            <Accordion
                                key={index}
                                expanded={expanded === index}
                                onChange={handleChange(index)}
                                sx={{
                                    backgroundColor: "#FFFAE0", // Light yellow box
                                    boxShadow: "none",
                                    border: "1px solid #FFD230",
                                    borderRadius: "10px",
                                    marginBottom: "10px",
                                    "&::before": { display: "none" },
                                    marginTop: 2
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    sx={{
                                        fontWeight: "bold",
                                        padding: "15px 20px",
                                    }}
                                >
                                    {faq.question}
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography style={{textAlign: 'left'}}>{faq.answer || "Answer coming soon!"}</Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Box>
                </Box>


            </div>
        </div >
    );
};

const styles = {
    container: {
        backgroundImage: `url(${BgImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        color: 'white',
        textAlign: 'center',
        boxSizing: 'border-box',
        overflow: 'hidden'
    },
    content: {
        padding: '20px',
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    innerBox: {
        width: '80%',
        backgroundColor: 'rgba(0, 0, 0, 1)',
        padding: '20px',
        borderRadius: '15px',
        border: '1px solid #2c2a25',
        boxSizing: 'border-box',
        marginTop: 20,
        border: '2px dashed #ffd125',

    },
    blackBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',

    },
    leftBox: {
        width: '45%',
        textAlign: 'left',
        padding: '20px',
        boxSizing: 'border-box',
        borderRadius: '15px'
    },
    rightBox: {
        width: '45%',
        padding: '20px',
        boxSizing: 'border-box',
        borderRadius: '15px',
    }
};

export default Faq;
